document.addEventListener("DOMContentLoaded", () => {
	const toc = document.querySelector("[data-sticky-toc]");
	const mastheadToc = document.querySelector("[data-sticky-toc-masthead]");

	if (!toc && !mastheadToc) {
		return;
	}

	const masthead =
		document.getElementById("masthead") || document.querySelector(".masthead");
	const adminBar = document.getElementById("wpadminbar");
	const trigger = toc ? toc.querySelector("[data-toc-trigger]") : null;
	const currentLabel = toc ? toc.querySelector("[data-toc-current]") : null;
	// On Marquee + in-masthead-TOC pages the dropdown UI extends up to
	// the lg/1024px hamburger threshold (the horizontal .masthead__toc-bar
	// is hidden below lg, see _sticky-toc.scss). On non-toc-bar pages the
	// sidebar layout still kicks in at md so the dropdown UI only fires
	// below md (the original behavior).
	const tocBarPage = document.body.classList.contains("has-masthead-toc-bar");
	const mobileQuery = window.matchMedia(
		tocBarPage ? "(max-width: 63.9375em)" : "(max-width: 61.9375em)"
	);

	const verticalLinks = toc
		? Array.from(
				toc.querySelectorAll(".advance-page-sticky-toc__link[href^='#']")
		  )
		: [];

	const mastheadLinks = mastheadToc
		? Array.from(
				mastheadToc.querySelectorAll(".masthead__link[href^='#']")
		  )
		: [];

	// Per-section-header breadcrumb links (rendered on every non-hero
	// .toc-section-header on marquee pages by templates/advance-page.php).
	// The breadcrumb's "page title" link points at the first TOC anchor
	// (e.g. `#hma-mission`). Including it here gives it the same click
	// handler as masthead/sidebar TOC links so clicking it returns the
	// user to the hero in-place instead of doing a full page reload.
	const breadcrumbLinks = Array.from(
		document.querySelectorAll(".toc-section-breadcrumb .breadcrumb-data[href^='#']")
	);

	// Combined link set; the vertical (in-page) TOC, the horizontal
	// in-masthead TOC, and the per-section-header breadcrumb "page title"
	// link share the same anchor targets, so we toggle is-active on every
	// link that matches the active section regardless of which bar/place
	// it lives in.
	const links = [...verticalLinks, ...mastheadLinks, ...breadcrumbLinks];

	// Marquee hero's TOC anchor — used to detect when a non-hero TOC
	// section is active so we can force the masthead into is-solid (see
	// the `wdg:toc-section-change` listener in header.php's IIFE) and
	// flip a body class CSS can hook into. Empty on non-marquee pages.
	const heroEl = document.getElementById("hero-marquee-header");
	const heroAnchor = heroEl ? heroEl.dataset.tocSection || "" : "";

	const uniqueIds = Array.from(
		new Set(
			links
				.map((link) => link.getAttribute("href").replace(/^#/, ""))
				.filter(Boolean)
		)
	);

	const sections = uniqueIds
		.map((id) => document.getElementById(id))
		.filter(Boolean);

	// Per-TOC-item page headers rendered by templates/advance-page.php on
	// marquee pages: the marquee hero + each non-CTA TOC item gets its own
	// <header data-toc-section="<anchor>"> and we toggle .is-active on the
	// matching one. CSS in _page-header.scss hides the non-active ones.
	// On non-marquee pages this list is empty and the loop is a no-op.
	const sectionHeaders = Array.from(
		document.querySelectorAll("[data-toc-section]")
	);

	const labelFor = (id) => {
		const link = links.find(
			(l) => l.getAttribute("href").replace(/^#/, "") === id
		);
		if (!link) return "";
		const span = link.querySelector("span");
		return span ? span.textContent.trim() : link.textContent.trim();
	};

	const showSection = (activeId) => {
		sections.forEach((section) => {
			section.style.display = section.id === activeId ? "" : "none";
		});

		sectionHeaders.forEach((headerEl) => {
			const matches = headerEl.dataset.tocSection === activeId;
			headerEl.classList.toggle("is-active", matches);
		});

		links.forEach((link) => {
			const id = link.getAttribute("href").replace(/^#/, "");
			link.classList.toggle("is-active", id === activeId);
		});

		if (currentLabel) {
			const text = labelFor(activeId);
			if (text) currentLabel.textContent = text;
		}

		// Marquee pages only: when a non-hero TOC section is active the
		// masthead should be in is-solid state regardless of scroll.
		// Flip a body class CSS can hook into and dispatch a custom event
		// that header.php's masthead IIFE listens for to re-run its
		// state-update routine immediately on TOC click.
		const isNonHero = heroAnchor !== "" && activeId !== heroAnchor;
		document.body.classList.toggle("toc-non-hero-active", isNonHero);
		window.dispatchEvent(
			new CustomEvent("wdg:toc-section-change", {
				detail: { activeId, isNonHero },
			})
		);
	};

	if (sections.length > 0) {
		showSection(sections[0].id);
	}

	const getAdminBarH = () => {
		if (!adminBar) return 0;
		if (document.body.classList.contains("adminbar-hidden")) return 0;
		return adminBar.offsetHeight || 0;
	};

	const getMastheadBottom = () => {
		if (!masthead) return getAdminBarH();
		const rect = masthead.getBoundingClientRect();
		const styles = window.getComputedStyle(masthead);
		const isFixed = styles.position === "fixed" || styles.position === "sticky";
		if (isFixed) {
			return Math.max(0, rect.bottom);
		}
		return getAdminBarH();
	};

	const updateStickyOffset = () => {
		if (!toc) return;
		const offset = getMastheadBottom() + 16;
		toc.style.setProperty("--wdg-sticky-toc-top", offset + "px");
	};

	const closeMobile = () => {
		if (!toc) return;
		toc.classList.remove("is-open");
		if (trigger) trigger.setAttribute("aria-expanded", "false");
	};

	const openMobile = () => {
		if (!toc) return;
		toc.classList.add("is-open");
		if (trigger) trigger.setAttribute("aria-expanded", "true");
	};

	const isMobile = () => mobileQuery.matches;

	const scrollToContent = () => {
		if (!toc) return;
		const offset = getMastheadBottom() + 8;
		const target = toc.getBoundingClientRect().top + window.scrollY - offset;
		window.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
	};

	links.forEach((link) => {
		link.addEventListener("click", (event) => {
			event.preventDefault();
			const id = link.getAttribute("href").replace(/^#/, "");
			showSection(id);
			history.replaceState(null, "", "#" + id);
			// Only the in-page sidebar TOC has a mobile dropdown that needs
			// closing + scrolling-to-content after a click. The horizontal
			// masthead variant is desktop-only.
			if (toc && isMobile()) {
				closeMobile();
				scrollToContent();
			}
		});
	});

	if (trigger) {
		trigger.addEventListener("click", () => {
			if (toc.classList.contains("is-open")) {
				closeMobile();
			} else {
				openMobile();
			}
		});
	}

	if (toc) {
		document.addEventListener("click", (event) => {
			if (!toc.classList.contains("is-open")) return;
			if (toc.contains(event.target)) return;
			closeMobile();
		});

		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape" && toc.classList.contains("is-open")) {
				closeMobile();
				if (trigger) trigger.focus();
			}
		});
	}

	const hash = window.location.hash.replace(/^#/, "");
	if (hash && sections.some((s) => s.id === hash)) {
		showSection(hash);
	}

	updateStickyOffset();
	window.addEventListener("resize", updateStickyOffset);
	window.addEventListener("scroll", updateStickyOffset, { passive: true });

	if (typeof mobileQuery.addEventListener === "function") {
		mobileQuery.addEventListener("change", () => {
			if (!isMobile()) closeMobile();
		});
	} else if (typeof mobileQuery.addListener === "function") {
		mobileQuery.addListener(() => {
			if (!isMobile()) closeMobile();
		});
	}

	// --- Adaptive TOC text color and alignscreen bleed offsets only apply
	// to the vertical sidebar TOC. When only the horizontal in-masthead
	// TOC is present (Marquee + toc_in_masthead), there's no sidebar to
	// adapt and no .alignfull bleed treatment to measure.
	if (!toc) {
		return;
	}

	// --- Adaptive TOC text color based on the bleed-emitting block(s)
	// currently behind the TOC. Two passes per update:
	//   1. TOC-level: dominant section over the whole TOC -> drives the
	//      panel border and (on mobile) the dropdown trigger surface.
	//   2. Per-link: dominant section behind each link's own rect ->
	//      drives that link's text/background/left-accent. Lets links
	//      flip individually as you scroll past a section boundary
	//      instead of all snapping at once.
	// CSS in assets/scss/global/_sticky-toc.scss reacts to the classes.
	const bleedSelector = [
		".advance-page-content .gb-block-container.has-background",
		".advance-page-content .gb-block-container[style*='background-color']",
		".advance-page-content .gb-block-container.gb-has-custom-background-color",
		".advance-page-content .wp-block-columns > .wp-block-column.has-background",
	].join(",");

	const bleedSources = Array.from(document.querySelectorAll(bleedSelector));

	const parseRGB = (str) => {
		const m = str.match(/rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)/i);
		return m ? [+m[1], +m[2], +m[3]] : null;
	};

	const luminance = (rgb) => {
		const norm = (v) => {
			const c = v / 255;
			return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
		};
		return 0.2126 * norm(rgb[0]) + 0.7152 * norm(rgb[1]) + 0.0722 * norm(rgb[2]);
	};

	const findDominantBleedFor = (rect) => {
		let best = null;
		let bestOverlap = 0;
		for (const el of bleedSources) {
			if (el.offsetParent === null) continue; // skip hidden tab sections
			const r = el.getBoundingClientRect();
			const overlap = Math.max(
				0,
				Math.min(rect.bottom, r.bottom) - Math.max(rect.top, r.top)
			);
			if (overlap > bestOverlap) {
				bestOverlap = overlap;
				best = el;
			}
		}
		return best;
	};

	const applyContrast = (target, bleedEl) => {
		if (!bleedEl) {
			target.classList.remove("is-on-dark", "is-on-light");
			return;
		}
		const rgb = parseRGB(getComputedStyle(bleedEl).backgroundColor);
		if (!rgb) {
			target.classList.remove("is-on-dark", "is-on-light");
			return;
		}
		const isDark = luminance(rgb) < 0.5;
		target.classList.toggle("is-on-dark", isDark);
		target.classList.toggle("is-on-light", !isDark);
	};

	// Elements that should adapt independently to whatever bleed is
	// behind them (the title sits at the top of the panel, links scroll
	// past section boundaries — both want their own contrast).
	const title = toc.querySelector(".advance-page-sticky-toc__title");
	const perElementTargets = [...(title ? [title] : []), ...verticalLinks];

	const updateTocContrast = () => {
		if (!bleedSources.length) {
			toc.classList.remove("is-on-dark", "is-on-light");
			perElementTargets.forEach((el) =>
				el.classList.remove("is-on-dark", "is-on-light")
			);
			return;
		}
		// TOC-level (drives panel border + mobile trigger).
		applyContrast(toc, findDominantBleedFor(toc.getBoundingClientRect()));
		// Per-element (drives each title/link's text/bg/left-accent).
		perElementTargets.forEach((el) => {
			applyContrast(el, findDominantBleedFor(el.getBoundingClientRect()));
		});
	};

	updateTocContrast();
	window.addEventListener("scroll", updateTocContrast, { passive: true });
	window.addEventListener("resize", updateTocContrast);

	// --- Bleed offset measurement for .alignscreen blocks inside the
	// has-toc layout. The advance-page-layout sits inside an article
	// that may itself be centered (page_width=wide caps it at
	// --wdg-width-wide), so on viewports wider than that the content
	// column does NOT line up with the viewport edges. A static
	// margin-inline-start: -(240px + gap) only compensates for the
	// TOC+gap offset inside the layout, not the article's centering
	// offset. Measure the column's real left/right gap to the viewport
	// and publish them as CSS variables for the global .alignscreen
	// rule in assets/scss/wordpress/_alignscreen.scss to consume.
	const layout = toc.closest(".advance-page-layout.has-toc");
	const contentColumn = layout
		? layout.querySelector(".advance-page-content")
		: null;
	// .entry-header is a sibling of .advance-page-layout inside the article,
	// so CSS variables set on the layout don't cascade up to the header.
	// Publish the same offsets on the parent <article> too so the header's
	// .header-content can mirror the content column's x-min/x-max.
	const article = layout ? layout.closest("article") : null;

	if (layout && contentColumn) {
		const clearBleedOffsets = () => {
			layout.style.removeProperty("--alignscreen-start");
			layout.style.removeProperty("--alignscreen-end");
			if (article) {
				article.style.removeProperty("--header-content-offset-left");
				article.style.removeProperty("--header-content-offset-right");
			}
		};

		const updateBleedOffsets = () => {
			if (isMobile()) {
				clearBleedOffsets();
				return;
			}
			const rect = contentColumn.getBoundingClientRect();
			const startOffset = rect.left;
			const endOffset = window.innerWidth - rect.right;
			layout.style.setProperty("--alignscreen-start", startOffset + "px");
			layout.style.setProperty("--alignscreen-end", endOffset + "px");
			if (article) {
				article.style.setProperty(
					"--header-content-offset-left",
					startOffset + "px"
				);
				article.style.setProperty(
					"--header-content-offset-right",
					endOffset + "px"
				);
			}
		};

		let bleedRafId = 0;
		const scheduleBleedUpdate = () => {
			if (bleedRafId) return;
			bleedRafId = requestAnimationFrame(() => {
				bleedRafId = 0;
				updateBleedOffsets();
			});
		};

		updateBleedOffsets();

		window.addEventListener("resize", scheduleBleedUpdate);
		window.addEventListener("orientationchange", scheduleBleedUpdate);

		if (typeof ResizeObserver === "function") {
			const ro = new ResizeObserver(scheduleBleedUpdate);
			ro.observe(contentColumn);
		}

		if (typeof mobileQuery.addEventListener === "function") {
			mobileQuery.addEventListener("change", scheduleBleedUpdate);
		} else if (typeof mobileQuery.addListener === "function") {
			mobileQuery.addListener(scheduleBleedUpdate);
		}
	}
});
